<template>
  <router-link
    :to="to"
    class="box-link"
    :class="type"
  >
    <div class="box-link-content">
      <h2 class="title is-4">
        <slot name="title">
          {{ title }}
        </slot>
      </h2>
      <p class="subtitle">
        {{ subtitle }}
      </p>
    </div>
    <div class="box-link-arrow">
      <b-icon icon="chevron-right" />
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    title: {
      default: null,
      type: String
    },
    subtitle: {
      required: true,
      type: String
    },
    to: {
      required: true,
      type: String
    },
    type: {
      default: undefined,
      type: String
    }
  }
};
</script>
